import React, { useState, Suspense , lazy} from "react";
const ShuffleStationsModal = lazy(() =>
  import(/* webpackChunkName: "shhlestm" */ "./ShuffleStationsModal")
);
import { Tooltip } from "@material-ui/core";
import LoadingSection from "../parts/LoadingSection";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ShuffleStations = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Tooltip title="Select Stations to Shuffle">
        <div className="hover-link" onClick={handleClickOpen}>
          Shuffle Stations <FontAwesomeIcon icon="edit" className="ml-2" />
        </div>
      </Tooltip>
      <Suspense fallback={<LoadingSection type="loading-section" />}>
        {open && <ShuffleStationsModal open={open} onClose={handleClose} />}
      </Suspense>
    </div>
  );
};

export default ShuffleStations;
